import { useEffect, useState } from "react";

export function Skeleton({ className = "" }) {
  return <div aria-hidden className={`rounded-md bg-surface-2 ${className}`} />;
}

export function SlowHint({ label = "Sto sincronizzando con GHL…", after = 3000 }) {
  const [show, setShow] = useState(false);
  useEffect(() => { const t = setTimeout(() => setShow(true), after); return () => clearTimeout(t); }, [after]);
  if (!show) return null;
  return <p className="text-center text-sm text-slate-500 fade-up" data-testid="slow-hint" role="status">{label}</p>;
}

export function SkeletonKpi() {
  return (
    <div className="athanor-card p-5" data-testid="skeleton-kpi">
      <Skeleton className="h-3.5 w-28" />
      <Skeleton className="mt-3 h-8 w-24" />
      <Skeleton className="mt-2 h-3 w-36" />
    </div>
  );
}

export function SkeletonCard({ rows = 4, chart = false, title = true }) {
  return (
    <div className="athanor-card p-6" data-testid="skeleton-card">
      {title && <Skeleton className="h-5 w-48" />}
      {chart ? <Skeleton className="mt-5 h-44 w-full" /> : (
        <div className="mt-5 space-y-3">
          {Array.from({ length: rows }).map((_, i) => <Skeleton key={i} className={`h-4 ${i % 3 === 0 ? "w-11/12" : i % 3 === 1 ? "w-2/3" : "w-4/5"}`} />)}
        </div>
      )}
    </div>
  );
}

export function SkeletonKpiGrid({ n = 4 }) {
  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-3 xl:grid-cols-4" data-testid="skeleton-kpi-grid">
      {Array.from({ length: n }).map((_, i) => <SkeletonKpi key={i} />)}
    </div>
  );
}

export function PageSkeleton({ kpis = 0, cards = 2, chart = false, hint }) {
  return (
    <div className="space-y-6" data-testid="page-skeleton">
      {kpis > 0 && <SkeletonKpiGrid n={kpis} />}
      {Array.from({ length: cards }).map((_, i) => <SkeletonCard key={i} chart={chart && i === 0} />)}
      <SlowHint label={hint} />
    </div>
  );
}
